/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, CSSProperties } from 'react';
import { KTSVG } from '../../../../_mexablock/helpers';
import {
  formatToDayMonth,
  getVigenciaLabel,
} from '../../../../_mexablock/helpers';
import { Collapse } from 'react-bootstrap-v5';
import { RadialDataGraphic } from '../../../../_mexablock/partials/widgets/graphics/radialData';
import { GraficaTransaccionesData } from './GraficaTransacciones';
import { ProgressGraphicData } from '../../../../_mexablock/partials/widgets/graphics/progressData';

type Props = {
  dataView?: any;
  dataAPP?: any;
  collapse: boolean;
  vigencia: string;
  name: string;
};

const CollapseGraphic: React.FC<Props> = ({
  dataView,
  dataAPP,
  collapse,
  vigencia,
  name,
}) => {
  const [openSectionInfoGeneral, setOpenSectionInfoGeneral] =
    useState<boolean>(collapse);

  const containerStyle: CSSProperties = {
    width: '100%',
    textAlign: 'center',
    borderRadius: '5px',
    backgroundColor: 'white',
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12 mb-xl-12">
          <div className="card border">
            <div
              className="card-header border-0 cursor-pointer d-flex justify-content-between align-items-center"
              onClick={() => setOpenSectionInfoGeneral(!openSectionInfoGeneral)}
              aria-controls="collapseExample"
            >
              <div className="d-flex align-items-center">
                <h3 className="fw-bolder m-0 ms-3 me-3 text-primary">
                  Paquete {name}
                </h3>
                <p className="p-0 m-0 fw-bold" style={{ color: '#f39c12' }}>
                  {getVigenciaLabel(vigencia)}
                </p>
              </div>
              <div className="justify-content-center align-items-center">
                <div
                  className={`align-self-center`}
                  style={{
                    transform: openSectionInfoGeneral
                      ? 'translateX(10%) rotate(-180deg)'
                      : '',
                    transition: 'transform 0.3s ease',
                  }}
                >
                  <KTSVG
                    path={'/media/icons/duotune/arrows/arr072.svg'}
                    className={`svg-icon-1`}
                  />
                </div>
              </div>
            </div>
            <Collapse in={openSectionInfoGeneral}>
              <div id="collapseExample">
                <div className="card-body border-top">
                  {/* Aqui van las graficas */}
                  <div
                    className="d-flex flex-row align-items-stretch gap-3"
                    style={{ ...containerStyle }}
                  >
                    {dataView ? (
                      <>
                        <div
                          className="flex-grow-1 border border-gray-300"
                          style={{ borderRadius: '5px' }}
                        >
                          <GraficaTransaccionesData
                            key={JSON.stringify(dataView?.days)}
                            vigencia={vigencia}
                            total={dataView.total}
                            height={300}
                            show={true}
                            series={[
                              {
                                name: 'Saldo consumido',
                                data: dataView.days.map((d: any) => d.amount),
                              },
                            ]}
                            colors={['#0d6efd']}
                            categories={dataView.days.map((d: any) =>
                              formatToDayMonth(d.date)
                            )}
                          />
                        </div>

                        <div
                          className="border border-gray-300"
                          style={{
                            width: '25%',
                            borderRadius: '5px',
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-center h-100">
                            <RadialDataGraphic
                              total={dataView.total}
                              consumo={dataView.consumption}
                              disponible={dataView.available}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div className="row mt-5">
                    {dataAPP &&
                      dataAPP.map((item: any) => {
                        return (
                          <div className="col-6" key={item.network_service.id}>
                            <ProgressGraphicData
                              disponible={item?.total}
                              porcentage={item?.percentage}
                              saldo={item?.network_service?.name}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export { CollapseGraphic };
